// removed by extract-text-webpack-plugin
module.exports = {"registration-form":"registration-form__w2i1g"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleForm/styles/RegistrationForm.scss
// module id = 6yzk
// module chunks = 1